import { HTMLAttributes } from 'react'
import { SvgIconType, SvgIcon } from '@integration-app/react'
import clsx from 'clsx'

import { Pane, VBox } from 'components/Layout'
import { css } from 'styled-system/css'
import { HStack, HstackProps } from 'styled-system/jsx'
import { Icon } from 'ui-kit/icon'

import classes from './Loader.module.css'

export function CircularLoader({ className, ...props }: HTMLAttributes<HTMLOrSVGElement>) {
  return (
    <svg className={clsx(classes.loaderCircular, className)} {...props} viewBox='22 22 44 44'>
      <circle cx='44' cy='44' r='20.2' fill='none' />
    </svg>
  )
}

export function FullHeightCircularLoader() {
  return (
    <div className={'flex flex-col justify-center items-center h-full'}>
      <CircularLoader />
    </div>
  )
}

export function LogoLoader({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={clsx('appLogoLoader', className)}
      viewBox='0 0 32 22'
      id='svgLogo'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <defs>
        <mask id='a'>
          <rect width='100%' height='100%' fill='#fff'></rect>
          <path d='M11.8 13.12a3 3 0 0 1 0-4.24l7.08-7.07a3 3 0 0 1 4.24 0l7.07 7.07a3 3 0 0 1 0 4.24l-7.07 7.07a3 3 0 0 1-4.24 0l-7.07-7.07Z'>
            <animateTransform
              attributeName='transform'
              attributeType='XML'
              type='rotate'
              repeatCount='indefinite'
              calcMode='spline'
              keyTimes='0;1'
              dur='5s'
              keySplines='0 0 0.1 1'
              from='0 21 11'
              to='-360 21 11'
            ></animateTransform>
          </path>
        </mask>
        <mask id='b'>
          <rect width='100%' height='100%' fill='#fff'></rect>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M1.8 8.88a3 3 0 0 0 0 4.24l7.08 7.07a3 3 0 0 0 4.24 0l7.07-7.07a3 3 0 0 0 0-4.24L13.12 1.8a3 3 0 0 0-4.24 0L1.8 8.88Zm.71.7a2 2 0 0 0 0 2.83L9.6 19.5a2 2 0 0 0 2.82 0l7.08-7.08a2 2 0 0 0 0-2.82l-7.1-7.1a2 2 0 0 0-2.82 0L2.5 9.6Z'
          >
            <animateTransform
              attributeName='transform'
              attributeType='XML'
              type='rotate'
              repeatCount='indefinite'
              calcMode='spline'
              keyTimes='0;1'
              dur='5s'
              keySplines='0 0 0.1 1'
              from='0 11 11'
              to='720 11 11'
            ></animateTransform>
          </path>
        </mask>
      </defs>
      <g mask='url(#a)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.8 8.88a3 3 0 0 0 0 4.24l7.08 7.07a3 3 0 0 0 4.24 0l7.07-7.07a3 3 0 0 0 0-4.24L13.12 1.8a3 3 0 0 0-4.24 0L1.8 8.88Zm.71.7a2 2 0 0 0 0 2.83L9.6 19.5a2 2 0 0 0 2.82 0l7.08-7.08a2 2 0 0 0 0-2.82l-7.1-7.1a2 2 0 0 0-2.82 0L2.5 9.6Z'
        >
          <animateTransform
            attributeName='transform'
            attributeType='XML'
            type='rotate'
            repeatCount='indefinite'
            calcMode='spline'
            keyTimes='0;1'
            dur='5s'
            keySplines='0 0 0.1 1'
            from='0 11 11'
            to='720 11 11'
          ></animateTransform>
        </path>
      </g>
      <g mask='url(#b)'>
        <path d='M11.8 13.12a3 3 0 0 1 0-4.24l7.08-7.07a3 3 0 0 1 4.24 0l7.07 7.07a3 3 0 0 1 0 4.24l-7.07 7.07a3 3 0 0 1-4.24 0l-7.07-7.07Z'>
          <animateTransform
            attributeName='transform'
            attributeType='XML'
            type='rotate'
            repeatCount='indefinite'
            calcMode='spline'
            keyTimes='0;1'
            dur='5s'
            keySplines='0 0 0.1 1'
            from='0 21 11'
            to='-360 21 11'
          ></animateTransform>
        </path>
      </g>
    </svg>
  )
}

export function EmptyPageLoader() {
  return (
    <div className={'noJsAppBackdrop appBackdrop'}>
      <LogoLoader className={clsx('appLogoLoader_startPage', 'noJsSpinner')} />
    </div>
  )
}

export function PaneLogoLoader() {
  return (
    <VBox className={css({ paddingBlockStart: '13vh' })}>
      <Pane
        stretch
        className={css({
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'start',
        })}
      >
        <LogoLoader />
      </Pane>
    </VBox>
  )
}

export function HStackLoader({ children, ...props }: HstackProps) {
  return (
    <HStack color='fg.muted' textStyle='sm' {...props}>
      <Icon size='sm'>
        <SvgIcon type={SvgIconType.Loader} />
      </Icon>
      {children}
    </HStack>
  )
}
